import { getExternalStoreMessages, useAuiState } from '@assistant-ui/react';
import { ANSWERING_MODEL_LABELS } from '@/workspace/model-choices.generated';

// Read the durable server data part, including its final update after fallback.
// Unknown identifiers never become a customer-facing label.
export function answeringModelLabel(parts: readonly unknown[]): string | null {
  for (const value of [...parts].reverse()) {
    if (!value || typeof value !== 'object') continue;
    const part = value as { type?: string; data?: { model?: unknown } };
    if (part.type !== 'data-ponevaModel' || typeof part.data?.model !== 'string') continue;
    return ANSWERING_MODEL_LABELS[part.data.model] ?? null;
  }
  return null;
}

export function AnswerModel() {
  const label = useAuiState((state) => {
    const original = getExternalStoreMessages(state.message)[0] as
      | { parts?: unknown[] }
      | undefined;
    return answeringModelLabel(original?.parts ?? state.message.parts);
  });
  return label ? (
    <span data-slot="answer-model" className="text-muted-foreground px-2 text-xs">
      {label}
    </span>
  ) : null;
}
